
export default function convertHoraire(horaire,mode){

    if (mode==="horaire"){ // convert numeric to hour format
        let heure = "";
        heure += Math.trunc(horaire); //get integer part of horaire as float
        heure += "h";
        let minutes = String((horaire - Math.trunc(horaire)) * 60); // get decimal part of horaire and multiply by 60 (60 minutes)
        if (minutes.length === 1) { minutes += "0"; } // when 0 minutes
        heure += minutes;

      return heure;  
    }
    

      if (mode==="numeric"){ // convert hour to numeric format
        return;
      }
}